import React from 'react'
import { Box, Flex, Link, Text } from '@clear/design-system'
import TopBanner from '@components/shared/TopBanner'
import PageContent from '@components/layout/PageContent'
import SmileIcon from '@assets/svgs/smile-icon'
import MapPinIcon from '@assets/svgs/map-pin-icon'
import { HeadTitle } from '@components/layout/HeadTitle'

const About = () => {
  return (
    <Flex flexDirection="column">
      <HeadTitle
        title="CLEAR vs TSA PreCheck® | What is the Difference?"
        description="CLEAR and TSA PreCheck® are complementary services. Use CLEAR's touchless technology for a faster, safer security experience - paired with TSA PreCheck® Enrollment Provided by CLEAR, keep your shoes, jacket and belt on; your laptop in its case; 3-1-1 compliant liquids in your bag; and enjoy a better overall travel experience."
      />
      <TopBanner />
      <PageContent>
        <Box mx="auto" maxWidth="content">
          <Text
            as="h1"
            variant="body"
            color="neutralsTextGray"
            mb={8}
            textAlign="center"
          >
            CLEAR is pleased to offer TSA&nbsp;PreCheck® enrollment. You can
            start online or walk up to any CLEAR airport location and apply on
            the spot — no appointment necessary!
          </Text>
          <Box as="ul">
            <Flex as="li" mb={6}>
              <Box width="3.1875rem" height="3.1875rem" flex="1 0 auto" mr={7}>
                <MapPinIcon />
              </Box>
              <Box flex="0 1 auto">
                <Text
                  as="h2"
                  mb={2}
                  fontSize={5}
                  variant="display"
                  color="brandDarkBlue"
                >
                  Enrolling is Easy
                </Text>
                <Text as="p" color="neutralsTextGray" variant="body">
                  Simply head{' '}
                  <Link variant="regular" color="brandDarkBlue" href="/">
                    here
                  </Link>{' '}
                  to get started, or visit us at any of our 50+ airport
                  locations nationwide where a friendly Ambassador can help you
                  start your application.
                </Text>
              </Box>
            </Flex>
            <Flex as="li" mb={6}>
              <Box width="3.1875rem" height="3.1875rem" flex="1 0 auto" mr={7}>
                <SmileIcon />
              </Box>
              <Box flex="0 1 auto">
                <Text
                  as="h2"
                  mb={2}
                  fontSize={5}
                  variant="display"
                  color="brandDarkBlue"
                >
                  Faster, Easier Experiences
                </Text>
                <Text as="p" color="neutralsTextGray" variant="body">
                  At CLEAR, we’re dedicated to making your journey seamless.
                  Combine both TSA&nbsp;PreCheck® and CLEAR Plus for the fastest
                  route to your gate. (Plus, learn more about how you can bundle
                  and save!)
                </Text>
              </Box>
            </Flex>
          </Box>
        </Box>
      </PageContent>
    </Flex>
  )
}

export default About
